export default 'Stratégie énergie ETI & CEE | Solution Éco France';
